import React from 'react';
import { func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import useStyles from 'hooks/useStyles';

import Button from 'components/Button';
import { ReactComponent as Eve } from './images/eve-instructor-list.svg';

import styles from './Jumbotron.scss';

function Jumbotron({ onCtaClick }) {
  const { t } = useTranslation(['instructorProfile']);
  useStyles(styles);

  return (
    <div className={styles.root}>
      <Eve className={styles.eve} />
      <div className={styles.content}>
        <h1
          className={styles.title}
          dangerouslySetInnerHTML={{
            __html: t('instructorList.jumbotron.title'),
          }}
        />

        <Button reversed onClick={onCtaClick}>
          {t('instructorList.jumbotron.cta')}
        </Button>
      </div>
    </div>
  );
}
Jumbotron.propTypes = { onCtaClick: func.isRequired };
export default Jumbotron;
